import type {HomeSummaryPageItem} from '@interfaces/usage/homeSummary'
import type {UserProfileInterface} from '@interfaces/user'
import {buildSignalExplorerUrl} from '@shared/utils/signalExplorerUrl'

export const HOME_ROUTE = '/home'
export const LEGACY_HOME_ROUTE = '/lines_overview?view=grid'

export const getPreferredHomeRoute = (
  homeViewMode?: UserProfileInterface['home_view_mode'] | null,
): string => (homeViewMode === 'legacy' ? LEGACY_HOME_ROUTE : HOME_ROUTE)

export const isLegacyHomePath = (pathname: string): boolean =>
  pathname.startsWith('/lines_overview')

export const getHomePageRoute = (summary: HomeSummaryPageItem): string => {
  const {
    page,
    object_type: objectType,
    object_uuid: objectUuid,
    search_params: searchParams,
  } = summary

  let route = '/'

  if (page === 'home') {
    route = HOME_ROUTE
  } else if (page === 'lines_overview') {
    route = LEGACY_HOME_ROUTE
  } else if (page === 'dashboard' && objectType === 'equipment' && objectUuid) {
    route = `/equipment/${objectUuid}`
  } else if (page === 'dashboard' && objectType === 'line' && objectUuid) {
    route = `/line/${objectUuid}`
  } else if (page === 'signals' && objectType === 'line' && objectUuid) {
    // Recorded visits to the retired per-line signals page reopen in the Signal
    // Explorer. Their stored search_params speak that page's dialect
    // (tab/batch/anomaly), so they are dropped instead of appended.
    return buildSignalExplorerUrl({lineId: objectUuid})
  } else if (page === 'line_management' && objectType === 'line' && objectUuid) {
    route = `/line/${objectUuid}/line_management`
  } else if (page === 'equipment_management' && objectType === 'equipment' && objectUuid) {
    route = `/equipment/${objectUuid}/equipment_management`
  } else if (page === 'settings') {
    route = '/settings'
  } else if (page === 'welcome') {
    route = '/welcome'
  } else if (page === 'incidents') {
    route = '/incidents'
  } else if (page === 'anomalies') {
    route = '/anomalies'
  } else if (page === 'logbook' || page === 'comments') {
    route = '/logbook'
  } else if (page === 'cockpit') {
    route = '/cockpit'
  } else if (page === 'batch_traceability') {
    route = '/batch_traceability'
  } else if (page === 'threshold_violations') {
    route = '/threshold-violations'
  } else if (page) {
    route = `/${page}`
  }

  return searchParams && route !== HOME_ROUTE && route !== LEGACY_HOME_ROUTE
    ? `${route}${searchParams.startsWith('?') ? searchParams : `?${searchParams}`}`
    : route
}
